import React from 'react'

import CompaniesImage from '../assets/companies.png'

const Companies = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:max-w-screen-2xl lg:px-8 space-y-8 py-12">
      <h3
        className="text-center text-3xl xs:text-2xl md:text-4xl font-semibold tracking-tight"
        style={{
          textDecoration: 'underline',
          textDecorationColor: '#FDBA74',
          textDecorationThickness: '10px',
          textDecorationSkipInk: 'none',
          textUnderlineOffset: '-40%',
          textUnderlinePosition: 'under'
        }}>
        Our Alumni Work at
      </h3>

      <img src={CompaniesImage.src} alt="" />
    </div>
  )
}

export default Companies
